import React from "react";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { Box, Grid } from "@material-ui/core";
import Linkref from "@material-ui/core/Link";
import ActionTypes from "../../constants/ActionTypes";
import useStyles from "../../themes/makeStyles";

export default function PageHeadingCreate(props) {
  /*
  signature:input title and path to navigate returns heading bar
  Description: this is used to display heading bar in every page with breadcrumb
  Purpose: to display heading and also display breadcrumb for path  
  */
  const classes = useStyles();
  return (

    <Box py={2}>
      <Box >
        <SimpleBreadcrumbs
          path={props.headingpath}
          className={classes.subText}
        />
      </Box>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item >
          <h3 className={classes.mainHeading}> {props.headingtitle}</h3>
        </Grid>
        <Grid item>
          <Box color={`${props.pageStatus === "Update" ? "warning.main" : "success.main"}`}>
            <Typography
              variant="h3"
              align="right"
              className={classes.statusHeading}
            >
              {props.pageStatus}
            </Typography>
          </Box>
          <Typography
            variant="h6"
            className={classes.statusSubHeading}
          >
            {props.pagePath}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}

function SimpleBreadcrumbs(props) {
  const subPath = props.path.split("/");
  // console.log(subPath);
  let path = "";
  const classes = useStyles();
  return (
    <Breadcrumbs aria-label="breadcrumb" className={classes.subText}>
      {subPath.map((sub, index) => {
        path = path + sub;
        if (index + 1 !== subPath.length) {
          if (sub !== ActionTypes.LOB) {
            return (
              <Linkref href={sub} className={classes.mainBreadcrumbs}>
                {sub}
              </Linkref>
            );
          }
        } else {
          return (
            <Typography color="textPrimary" className={classes.childBreadcrumbs}>
              {sub}
            </Typography>
          );
        }
      })}
    </Breadcrumbs>
  );
}
